import { render } from "./ButtonAuth.vue?vue&type=template&id=6728da81&ts=true"
import script from "./ButtonAuth.vue?vue&type=script&lang=ts"
export * from "./ButtonAuth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__